'use client'

import { TranslationFunction } from '@/src/types/translations'
import { smartSRPMessages } from '@/src/utils/srp/aiRecommendation/locale'
import { alpha, Box, Typography, useTheme } from '@mui/material'
import { InfoIcon } from 'lucide-react'
import { useLocale } from 'next-intl'
import React, { useMemo } from 'react'

type SmartPreferenceBannerVariant = 'partialMatch' | 'onlyPartialMatch'

interface SmartPreferenceBannerProps {
    tCommon: TranslationFunction<'common'>
    variant: SmartPreferenceBannerVariant
    compact?: boolean
}

const SmartPreferenceBanner: React.FC<SmartPreferenceBannerProps> = ({
    tCommon,
    variant,
    compact = false
}) => {
    const locale = useLocale() as 'en' | 'ar'
    const smartSRPMessagesData = useMemo(() => smartSRPMessages[locale], [locale])
    const message =
        variant === 'onlyPartialMatch'
            ? smartSRPMessagesData.smartPreferenceOnlyPartialMatch
            : smartSRPMessagesData.smartPreferencePartialMatch
    const theme = useTheme()

    return (
        <Box
            display="flex"
            alignItems="center"
            gap={0.75}
            my={1.5}
            px={1.5}
            py={1}
            borderRadius={0.75}
            sx={{ backgroundColor: alpha(theme.palette.info.main, 0.06) }}
        >
            <InfoIcon size={14} color={theme.palette.info.main} style={{ flexShrink: 0, marginTop: 1 }} />
            <Typography fontSize={13} fontWeight={600} color={'textPrimary'} lineHeight={1.5}>
                {message}
            </Typography>
        </Box>
    )
}

export { SmartPreferenceBanner }
